/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Test_FailedInputs */



/**
* | output |
* | --- |
* | "Calendar unreachable." |
*
* @param {Connections_Test_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_test_failed = /** @type {((inputs?: Connections_Test_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Test_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Agenda niet bereikbaar.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agenda inaccessible.")
	return /** @type {LocalizedString} */ ("Calendar unreachable.")
});